import React from 'react';
import { Box, Stack, IconButton, Typography, Button } from '@mui/material';
import ControlsOverlay from './ControlsOverlay';
import SilhouetteCarousel from './SilhouetteCarousel';

export default function CameraView({ 
  videoRef, 
  fileInputRef, 
  isCameraActive, 
  onCapture, 
  onUploadClick,
  captureReview,
  backgroundImage,
  onConfirm,
  onRetake,
  silhouetteImage,
  silhouettes,
  currentSilhouetteStartIndex,
  silhouettesPerPage,
  onSelectSilhouette,
  onNextSilhouettes,
  onPrevSilhouettes,
  silhouetteScale,
  silhouetteOpacity,
  transformHistory,
  transformFuture,
  onUndo,
  onRedo,
  onScaleChange,
  onOpacityChange
}) {
  return (
    <Box sx={{
      width: '100%', 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      backgroundColor: 'black',
    }}>
      <Box
        component="video"
        ref={videoRef}
        autoPlay
        playsInline
        sx={{
          width: '100%', 
          height: '100%', 
          objectFit: 'cover',
          display: captureReview ? 'none' : 'block',
          transform: 'scaleX(-1)',
        }}
      />
      {captureReview && backgroundImage && (
        <img 
          src={backgroundImage} 
          alt="Captured" 
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} 
        />
      )}

      {!captureReview && (
        <Stack 
          direction="row" 
          spacing={2} 
          justifyContent="center"
          sx={{
            position: 'absolute',
            bottom: '20px', 
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10 
          }}
        >
          <IconButton 
            color="primary" 
            aria-label="capture photo" 
            onClick={onCapture} 
            sx={{ 
              height: 56, 
              width: 56, 
              backgroundColor: 'rgba(0,0,0,0.3)', 
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.5)'}
            }}
          >
            <img src="/img/camera.png" alt="Capture" style={{ width: 32, height: 32 }} />
          </IconButton>
        </Stack>
      )}

      {/* Watermark for live camera feed */}
      {isCameraActive && (
        <Typography
          variant="caption"
          sx={{
            position: 'absolute',
            bottom: '15px',
            right: '15px',
            color: 'rgba(255, 255, 255, 0.5)',
            zIndex: 15,
            fontFamily: 'Arial',
            fontWeight: 'bold',
            fontSize: '16px',
            textShadow: '1px 1px 2px rgba(0,0,0,0.7)'
          }}
        >
          Nutscaper.com
        </Typography>
      )}

      {/* Overlay for Upload Button (shown when camera is active, moved here) */}
      {!captureReview && (
        <IconButton
          aria-label="upload image"
          onClick={onUploadClick}
          sx={{
            position: 'absolute',
            top: '10px',
            left: '10px',
            zIndex: 20, 
            backgroundColor: 'rgba(0,0,0,0.1)',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.3)'
            },
            p: '8px'
          }}
        >
          <img src="/img/Import.png" alt="Import" style={{ width: 24, height: 24 }} />
        </IconButton>
      )}

      {captureReview && (
        <>
          <ControlsOverlay
            silhouetteScale={silhouetteScale}
            silhouetteOpacity={silhouetteOpacity}
            transformHistory={transformHistory}
            transformFuture={transformFuture}
            onUndo={onUndo}
            onRedo={onRedo}
            onScaleChange={onScaleChange}
            onOpacityChange={onOpacityChange}
          />
          <SilhouetteCarousel
            silhouettes={silhouettes}
            silhouetteImage={silhouetteImage}
            currentSilhouetteStartIndex={currentSilhouetteStartIndex}
            silhouettesPerPage={silhouettesPerPage}
            onSelect={onSelectSilhouette}
            onPrev={onPrevSilhouettes}
            onNext={onNextSilhouettes}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              p: 2,
              display: 'flex',
              justifyContent: 'space-between',
              zIndex: 20,
              background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)'
            }}
          >
            <Button 
              onClick={onRetake}
              sx={{ 
                color: 'white', 
                backgroundColor: 'rgba(255,255,255,0.12)', 
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
                borderRadius: '20px',
                px: 3
              }}
            >
              Retake
            </Button>
            <Button 
              onClick={onConfirm}
              sx={{ 
                color: 'white', 
                background: 'linear-gradient(45deg, #7C3AED, #EC4899)', 
                '&:hover': { opacity: 0.9 },
                borderRadius: '20px',
                px: 3,
                fontWeight: 'bold'
              }}
            >
              Done ✓
            </Button>
          </Box>
        </>
      )}

    </Box>
  );
}
